import { render, staticRenderFns } from "./classifyEdit.vue?vue&type=template&id=2cf5c020"
import script from "./classifyEdit.vue?vue&type=script&lang=js"
export * from "./classifyEdit.vue?vue&type=script&lang=js"
import style0 from "./classifyEdit.vue?vue&type=style&index=0&id=2cf5c020&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports